export const coursesCategoryOptions = [
	{ value: 'all', label: 'All' },
	{ value: 'design', label: 'Design' },
	{ value: 'development', label: 'Development' },
	{ value: 'marketing', label: 'Marketing' },
	{ value: 'business', label: 'Business' },
	{ value: 'photography', label: 'Photography' },
	{ value: 'music', label: 'Music' },
	{ value: 'health', label: 'Health' },
];
